// Telemetry Severity Level

// See: "@microsoft/applicationinsights-common/types/Interfaces/Contracts/SeverityLevel";

// All properties sorted alphabetically.
export enum SeverityLevel {
  Critical = 4,
  Error = 3,
  Information = 1,
  Verbose = 0,
  Warning = 2,
}
